import type { Action } from 'vuex';
import api from '../api';
import type { AssessmentState } from './mutations';

const getAssessmentStatus: Action<AssessmentState, any> = async ({ commit }) => {
  const res = await api.getAssessmentStatus();
  commit('SET_ASSESSMENT_STATUS', res.data);
};

const confirmAnswerControlUpdate: Action<AssessmentState, any> = async (_store, answerID) => {
  await api.confirmAnswerControlUpdate(answerID);
};

const submitAssessment: Action<AssessmentState, any> = async ({ commit }) => {
  const res = await api.submitAssessment();
  commit('SET_ASSESSMENT_STATUS', res.data);
};

export const actions = {
  getAssessmentStatus,
  submitAssessment,
  confirmAnswerControlUpdate,
};
